import React from 'react';
import { Button, Slider } from 'antd';
import { useTranslation } from 'react-i18next';
import { TGDComponent } from '../../../../models/courses/graphicDesign';
import { SHAPE_SIDES } from '../../core/presets';

interface ShapesPanelProps {
  selected?: TGDComponent; onAdd: (sides: number) => void;
  onUpdate: (patch: Partial<TGDComponent>) => void;
}

const ShapesPanel: React.FC<ShapesPanelProps> = ({ selected, onAdd, onUpdate }) => {
  const { t } = useTranslation();
  return <section className="gd-panel">
    <h3>{t('graphicDesignLesson.editor.shapes')}</h3>
    <div className="gd-shape-grid">{SHAPE_SIDES.map(sides =>
      <Button key={sides} className="gd-shape-choice" onClick={() => onAdd(sides)}
        aria-label={t(`graphicDesignLesson.editor.shape.${sides}`)}>
        <svg viewBox="0 0 44 44" aria-hidden="true">
          {sides === 0 ? <circle cx="22" cy="22" r="16" />
            : <polygon points={Array.from({ length: sides }, (_, i) => {
              const angle = -Math.PI / 2 + 2 * Math.PI * i / sides;
              return `${22 + 17 * Math.cos(angle)},${22 + 17 * Math.sin(angle)}`;
            }).join(' ')} />}
        </svg>
      </Button>)}</div>
    {selected?.type === 'shape' && <div className="gd-panel-fields">
      {selected.sides !== 0 && selected.sides !== 4 && <label>
        {t('graphicDesignLesson.editor.sides')}
        <Slider min={3} max={10} value={selected.sides ?? 3}
          onChangeComplete={value => onUpdate({ sides: value })} />
      </label>}
      {selected.sides === 4 && <label>{t('graphicDesignLesson.editor.rounding')}
        <Slider min={0} max={60} value={selected.cornerRadius ?? 0}
          onChangeComplete={value => onUpdate({ cornerRadius: value })} /></label>}
      <label>{t('graphicDesignLesson.editor.outline')}
        <Slider min={0} max={20} value={selected.strokeWidth ?? 0}
          onChangeComplete={value => onUpdate({ strokeWidth: value })} /></label>
    </div>}
  </section>;
};

export default ShapesPanel;
